// extracted by mini-css-extract-plugin
module.exports = {"financieringskosten":"eigenwoningschuld-modal_financieringskosten__UNXKf","custom_percentage_input":"eigenwoningschuld-modal_custom_percentage_input__W3Ogk"};